export const sanitizePhoneNumber = (phoneNumber: string, prefix: string) => (
  prefix + phoneNumber.replace(/[\s()-]/g, '')
);

export default { sanitizePhoneNumber };
